import { ChevronDown } from "lucide-react";
import { useState } from "react";

const CustomSelect = ({
  item,
  selectedOption,
  setSelectedOption,
  setError,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative w-full">
      {/* SELECT BUTTON */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className={`w-full flex items-center justify-between px-4 py-2 bg-navy border rounded text-sm transition-all
          ${
            selectedOption
              ? "border-border text-yellowstar"
              : "border-gray-600 text-gray-400"
          }
        `}
      >
        <span>{selectedOption || "Select your option"}</span>

        <ChevronDown
          size={16}
          className={`transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {/* DROPDOWN */}
      {open && (
        <div className="absolute left-0 right-0 mt-2 bg-navy border border-border rounded shadow-lg z-50 overflow-hidden">
          {item.subdesc.map((option, index) => {
            const isActive = selectedOption === option;

            return (
              <button
                key={index}
                type="button"
                onClick={() => {
                  setSelectedOption(option);
                  setError("");
                  setOpen(false);
                }}
                className={`w-full text-left px-4 py-1 text-sm transition-all
                  ${
                    isActive
                      ? "bg-yellowstar/10 text-yellowstar"
                      : "text-yellowstar hover:bg-white/5"
                  }
                `}
              >
                {option}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
